import { InheritFromViewerClass } from "./DtViewer3D";
import { TOOLBAR_CREATED_EVENT } from "../gui/GuiViewerToolbarConst";

import { av, avp } from "@adsk/lmv";

export class DtGuiViewer3D extends InheritFromViewerClass(av.GuiViewer3D) {
	constructor(container, config) {
		config = config || {};

		config.skipEscNavHandling = true;

		// disabledExtensions is used when (un-)loading a list of hard-coded extensions in the base class.
		// We don't want it to manage extensions, so we report all possible extensions as 'disabled'.
		config.disabledExtensions = new Proxy({}, {
			get() {
				return true;
			}
		});

		super(container, config);
	}

	// ----- LMV class overrides -----

	tearDown() {
		if (this.navToolsExt) {
			this.navToolsExt.unload();
			this.navToolsExt = null;
		}

		super.tearDown();
	}

	initEscapeHandlers() {
		// no-op. We already register an escape handler in DtViewer3D.
		// Also see extraEscapeEventHandler below.
	}

	// this.checkGeometry is set and unset (= null) in LMV's GuiViewer3D.
	// It raises errors for empty models on load events.
	// Models can be empty in Tandem, so we make it a no-op.
	get checkGeometry() {
		// no-op
		return function() {};
	}

	set checkGeometry(value) { /* no-op */ }

	// ----- LMV class overrides end -----
	// ----- Tandem added -----

	waitForToolbar() {
		if (this.getToolbar()) {
			return Promise.resolve();
		}

		return new Promise(resolve => {
			const onToolbarCreated = () => {
				this.removeEventListener(TOOLBAR_CREATED_EVENT, onToolbarCreated);
				resolve();
			}
			this.addEventListener(TOOLBAR_CREATED_EVENT, onToolbarCreated);
		});
	}

	extraEscapeEventHandler() {
		// Render options isn't enabled in release, so don't try to manipulate it
		if (this.renderoptions) {
			// Close render settings panel
			if (this.renderoptions.isVisible()) {
				this.renderoptions.setVisible(false);
				return;
			}
		}

		// TODO: stop any active animation
		if (this.getActiveNavigationTool() !== this.getDefaultNavigationToolName()) {
			// Force unlock active tool:
			if (this.toolController)
				this.toolController.setIsLocked(false);

			this.setActiveNavigationTool();
			avp.HudMessage.dismiss();
			return;
		}

		// Close open alert windows
		if (avp.AlertBox.dismiss()) {
			return;
		}

		// Close open windows
		for (var i = 0; i < this.dockingPanels.length; ++i) {
			var panel = this.dockingPanels[i];
			if (panel.container.style.display !== "none" && panel.container.style.display !== "") {
				panel.setVisible(false);
				return;
			}
		}

		if (this.escapeScreenMode()) {
			return;
		}
	}

	// ----- Tandem added end -----
}
